import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/messages`;

export const studentMessagesRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
} as const;

export type IStudentMessagesRouteParams = IExtractRouteParamMap<
  typeof studentMessagesRoutesObj
>;

export const studentMessagesPath = createPaths<
  typeof studentMessagesRoutesObj,
  IStudentMessagesRouteParams
>(studentMessagesRoutesObj);
